// Hungarian company tax number (adószám): 12345678-1-23
// Same shape the backend validates with (CompanyEmploymentType._is_valid_adoszam)
export const COMPANY_TAX_NUMBER_REGEX = /^\d{8}-\d{1}-\d{2}$/;
